<div class="note-legacy-wrapper">

    <div class="note-legacy-tools">
        <core-helpers-forms-button-white [hidden]="!vnotesCtrl.hasUnsavedNotes()" [text]="'Save notes'" (submit)="sendNotes()"></core-helpers-forms-button-white>
    </div>

    <div #scroll class="notes-image-scroll">
        <div #bounds class="note-legacy"> <!-- this layer is x/y content -->
            <div #notesContainer (dblclick)="makeNote($event)" class="notes-image-container" >

                <core-preview-page *ngIf="page > 0" [fileId]="file.id" [page]="page" [format]="'big-width'" (onLoad)="previewLoad($event)"></core-preview-page>

                <core-legacy-note
                    [hidden]="!previewLoaded"
                    *ngFor="let vnote of vnotesCtrl.getByPage(legacyPage);"
                    [index]="vnote.index"
                    [note]="vnote.note"
                    [opened]="isSelected(vnote.note)"
                    [moveBounds]="notesBounds.nativeElement"
                    (onRemove)="deleteNote($event, vnote)"
                    (movingNote)="moveNote($event, vnote)"
                >
                </core-legacy-note>
            </div>
        </div>
    </div>


</div>
